// patient docs
export const PATIENT_DOCS_REQUESTED = 'PATIENT_DOCS_REQUESTED'
export const PATIENT_DOCS_RECIEVED = 'PATIENT_DOCS_RECIEVED'
export const PATIENT_DOCS_FAILED = 'PATIENT_DOCS_FAILED'
export const PATIENT_FILE_REQUESTED = 'PATIENT_FILE_REQUESTED'
export const PATIENT_FILE_RECEIVED = 'PATIENT_FILE_RECEIVED'
export const VISIT_SUMMARY_REQUESTED = 'VISIT_SUMMARY_REQUESTED'
export const VISIT_SUMMARY_RECEIVED = 'VISIT_SUMMARY_RECEIVED'
export const VISIT_SUMMARY_FAILED = 'VISIT_SUMMARY_FAILED'

// past visits
export const SET_PAST_VISITS_LIST = 'SET_PAST_VISITS_LIST'
export const SHOW_PAST_VISIT = 'SHOW_PAST_VISIT'
export const PAST_VISIT_REQUESTED = 'PAST_VISIT_REQUESTED'
export const PAST_VISIT_RECEIVED = 'PAST_VISIT_RECEIVED'

// work notes
export const SET_WORK_NOTES_BY_ID = 'SET_WORK_NOTES_BY_ID'
export const SHOW_WORK_NOTE = 'SHOW_WORK_NOTE'

// referrals
export const SET_REFERRALS_BY_ID = 'SET_REFERRALS_BY_ID'
export const SHOW_REFERRAL = 'SHOW_REFERRAL'

//account
export const ACCOUNT_PRESSED = 'ACCOUNT_PRESSED'

//prescriptions
export const SET_PRESCRIPTIONS_BY_ID = 'SET_PRESCRIPTIONS_BY_ID'
export const SHOW_PRESCRIPTIONS = 'SHOW_PRESCRIPTIONS'

//telemedicine consents
export const SET_CONSENTS_BY_ID = 'SET_CONSENTS_BY_ID'
export const SHOW_CONSENTS = 'SHOW_CONSENTS'

// analystics
export const PAST_VISITS_CLICK = 'PAST_VISITS_CLICK'
export const WORK_NOTES_CLICK = 'WORK_NOTES_CLICK'
export const REFERRALS_CLICK = 'REFERRALS_CLICK'
export const PRESCRIPTIONS_CLICK = 'PRESCRIPTIONS_CLICK'
export const CONSENTS_CLICK = 'CONSENTS_CLICK'
export const DISCOUNT_CARD_CLICK = 'DISCOUNT_CARD_CLICK'
export const SUPPORT_CLICK = 'SUPPORT_CLICK'
export const FAQ_CLICK = 'FAQ_CLICK'
export const MY_FAMILY_CLICK = 'MY_FAMILY_CLICK'
export const PAYMENT_DETAILS = 'PAYMENT_DETAILS'

// upload file
export const UPLOAD_FILE_PRESSED = 'UPLOAD_FILE_PRESSED'

// Quest Referrals
export const QUEST_REFERRALS_REQUESTED = 'QUEST_REFERRALS_REQUESTED'
export const QUEST_REFERRALS_RECEIVED = 'QUEST_REFERRALS_RECEIVED'
export const QUEST_REFERRALS_RESULTS_REQUESTED =
  'QUEST_REFERRALS_RESULTS_REQUESTED'
export const QUEST_REFERRALS_RESULTS_RECEIVED =
  'QUEST_REFERRALS_RESULTS_RECEIVED'
export const QUEST_REFERRALS_RESULTS_REQUESTED_FROM_NOTIFICATION =
  'QUEST_REFERRALS_RESULTS_REQUESTED_FROM_NOTIFICATION'
export const UPDATE_QUEST_REFERRALS_RESULTS_SEEN_STATUS_REQUESTED =
  'UPDATE_QUEST_REFERRALS_RESULTS_SEEN_STATUS_REQUESTED'
export const UPDATE_QUEST_REFERRALS_RESULTS_SEEN_STATUS_RECEIVED =
  'UPDATE_QUEST_REFERRALS_RESULTS_SEEN_STATUS_RECEIVED'
export const GENERIC_REFERRALS_REQUESTED = 'GENERIC_REFERRALS_REQUESTED'
export const GENERIC_REFERRALS_RECEIVED = 'GENERIC_REFERRALS_RECEIVED'
export const GENERIC_REFERRALS_RECEIVE_FAILED =
  'GENERIC_REFERRALS_RECEIVE_FAILED'
export const SELECTED_LAB_FACILITY_LOCATION_REQUESTED =
  'SELECTED_LAB_FACILITY_LOCATION_REQUESTED'
export const SELECTED_LAB_FACILITY_LOCATION_FAILED =
  'SELECTED_LAB_FACILITY_LOCATION_FAILED'
export const SELECTED_LAB_FACILITY_LOCATION_RECEIVED =
  'SELECTED_LAB_FACILITY_LOCATION_RECEIVED'
export const CLEAR_SELECTED_LAB_FACILITY_LOCATION_ =
  'CLEAR_SELECTED_LAB_FACILITY_LOCATION_'

export const REFERRAL_PDF_REQUESTED = 'REFERRAL_PDF_REQUESTED'
export const REFERRAL_PDF_RECIEVED = 'REFERRAL_PDF_RECIEVED'
export const VIEW_DOCUMENT_BY_URL = 'VIEW_DOCUMENT_BY_URL'
export const CLEAR_VIEW_DOCUMENT_BY_URL = 'CLEAR_VIEW_DOCUMENT_BY_URL'
export const NAV_TO_LAB_REFERRAL = 'NAV_TO_LAB_REFERRAL'
export const NAV_TO_QUEST_REFERRAL = 'NAV_TO_QUEST_REFERRAL'
